import { connect } from 'react-redux';
import AdminResetPasswordPage from 'pages/AdminResetPasswordPage';
import AdminActions from 'store/adminPanel/actions';

const mapStateToProps = state => {
  return {
    isResetPasswordRequesting: state.adminPanel.isResetPasswordRequesting,
    isPasswordReset: state.adminPanel.isPasswordReset,
  };
};
const mapDispatchToProps = {
  adminResetPassword: AdminActions.Creators.adminResetPasswordRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(AdminResetPasswordPage);
